import { Injectable } from '@angular/core';
import { Moment } from 'moment/moment';
import * as moment from 'moment/moment';
import { LanguageService } from './services/language.service';
import { BehaviorSubject } from 'rxjs';
import { MomentInput } from 'moment';

@Injectable({providedIn: 'root'})
export class DateService {

  public currentLanguageMomentCode: string;
  public localeChanged = new BehaviorSubject<void>(null)

  constructor(private languageService: LanguageService) {
    this.languageService.currentLanguage.subscribe(currentLanguage => {
      if (currentLanguage.momentCode) {
        this.currentLanguageMomentCode = currentLanguage.momentCode;
        moment.locale(this.currentLanguageMomentCode);
        this.localeChanged.next(null);
      }
    });
  }

  private computeDurationResult(fn: (to: MomentInput, suffix?: boolean) => string, fromDate: Moment, toDate: Moment = moment(), suffix: boolean = true): DurationResult {
    if (fromDate && toDate) {
      if (this.currentLanguageMomentCode) {
        fromDate = fromDate.clone().locale(this.currentLanguageMomentCode);
        toDate = toDate.clone().locale(this.currentLanguageMomentCode);
      }
      const duration = moment.duration(Math.abs(fromDate.diff(moment())));
      return new DurationResult(fn.apply(fromDate, [toDate, suffix]), duration.asDays() > 7);
    } else {
      return new DurationResult(null, null);
    }
  }

  durationFrom(fromDate: Moment, toDate: Moment = moment(), suffix: boolean = true): DurationResult {
    return this.computeDurationResult(moment.prototype.from, fromDate, toDate, suffix);
  }

  durationTo(fromDate: Moment, toDate: Moment = moment(), suffix: boolean = true): DurationResult {
    return this.computeDurationResult(moment.prototype.to, fromDate, toDate, suffix);
  }

  formatWithLocale(momentDate: moment.Moment, format: string = null): string {
    if (momentDate == null) {
      return null;
    }
    if (this.currentLanguageMomentCode) {
      momentDate = momentDate.clone().locale(this.currentLanguageMomentCode);
    }
    if (format) {
      return momentDate.format(format);
    }
    return momentDate.format();
  }
}

export class DurationResult {
  duration: string;
  formatNeeded: boolean;

  constructor(duration: string, formatNeeded: boolean) {
    this.duration = duration;
    this.formatNeeded = formatNeeded;
  }
}
